import { Close } from "@mui/icons-material";
import { Box, Modal, Typography } from "@mui/material";
import { useState } from "react";

interface PopupBlogProps {
  imgPath: string;
  title: string;
  content: string;
}

function PopupBlog({ imgPath, title, content }: PopupBlogProps) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        width="170px"
        sx={{
          cursor: "pointer",
          "&:hover": {
            opacity: 0.7,
          },
        }}
        onClick={handleOpen}
      >
        <Box
          width="170px"
          height="170px"
          component="img"
          alt="Pop up blog 1"
          src={imgPath}
        />
        <Typography fontWeight="bold" sx={{ my: 2 }}>
          {title}
        </Typography>

        <Typography color="primary">続きをみる</Typography>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            bgcolor: "white",
            outline: "none",
          }}
        >
          <Box position="relative" p={4}>
            <Box
              position="absolute"
              top={4}
              right={4}
              onClick={handleClose}
              sx={{ cursor: "pointer" }}
            >
              <Close />
            </Box>

            <Box display="flex">
              <Box
                width="200px"
                height="200px"
                component="img"
                alt="Pop up blog 1"
                src={imgPath}
              />
              <Box px={2}>
                <Typography fontWeight="bold" sx={{ my: 1 }}>
                  {title}
                </Typography>
                <Typography>{content}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default PopupBlog;
